
//8
Object.defineProperty(exports, "__esModule", { value: true });
require("../input-with-options/InputWithOptions.st.css");
require("../deprecated/divider/Divider.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "Autocomplete3712706663",
    {"root":"Autocomplete3712706663--root","divider":"Autocomplete3712706663--divider"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/autocomplete/Autocomplete.st.css
// module id = 1305
// module chunks = 0